import React from 'react';
import DocumentModuleV2 from './DocumentModuleV2';

export default function SalesOrdersV2() {
  return (
    <DocumentModuleV2
      kind="sales-orders"
      title="Sales Orders"
      counterpartyLabel="Buyer"
    />
  );
}
